<template>
  <div class="day-detail">
    <div class="wrapper">
      <header class="header">
        <span
          class="close"
          @click="close"
        >
          <CrossIcon class="cross"></CrossIcon>
        </span>
        <p class="date">{{ fullDate }}</p>
        <h2 class="title">Thee drinken met buuf</h2>
      </header>
      <div class="panel-holder">
        <div
          class="panel-holder-slide"
          ref="slide"
        >
          <DayDetailItem
            v-for="(panel, index) in panels"
            :key="index"
            :index="index"
            :last="index === panels.length - 1"
          >
            {{ panel }}
          </DayDetailItem>
        </div>
      </div>
      <transition name="button-anim">
        <button
          class="button"
          v-if="count > 0"
          @click="close"
        >
          + {{ count }} items
        </button>
      </transition>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import DayDetailItem from './DayDetailItem'
import { EventBus } from '@/EventBus'
import { CrossIcon } from '@/components/icons'
import { trackAlarm } from '@/utils/track'

export default {
  name: 'DayDetail',
  data () {
    return {
      count: 0,
      animationIndex: 0,
      panels: [
        'Wat ga ik zeggen?',
        'Welke thee ga ik drinken?',
        'Hoe ga ik zitten?',
        'Waar is het lepeltje?',
        'Neem ik suiker?',
        'Of een zoetje?',
        'Zwart shirt aan?',
        'Ohnee, misschien die blauwe',
        'Fietsen of lopen?',
        'Misschien wil ik wel snel weg',
        'Beter fietsen',
        'Wil ze me wel zien?',
        'Heeft ze me gemist?',
        'Kan ik dit wel?',
        'Nee, tuurlijk niet',
        'Je doet er niet toe',
        'Je kan toch niks',
        'Blijf maar in bed'
      ]
    }
  },
  mounted () {
    EventBus.$on('scrollUp', px => {
      if (this.$refs.slide) {
        this.$refs.slide.style.transform = `translateY(-${px}px)`
        this.count++
      }
    })
    // If the user still hasn't clicked anywhere
    // Just emit the 'close' event
    // Closes the Alarm component alltogether
    setTimeout(() => this.$emit('close'), 15000)
  },
  methods: {
    close () {
      trackAlarm('day-detail-close-click')
      this.$emit('close')
    }
  },
  computed: {
    fullDate () {
      return moment().locale('nl').format('dddd D MMMM')
    }
  },
  components: {
    DayDetailItem,
    CrossIcon
  }
}
</script>

<style lang="scss" scoped>
.day-detail {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 14px 14px 0 14px;
  text-align: left;
  z-index: 100;
  transition: all .3s cubic-bezier(.19,1,.22,1);
  bottom: 50px;

  @media (min-width: 768px) {
    bottom: 0;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
}
.wrapper {
  width: 100%;
  max-width: 345px;
  height: 100%;
  position: relative;
  margin: 0 auto;
  max-height: 450px;

  @media (min-width: 768px) {
    max-height: 500px;
  }
}
.header {
  border-radius: 5px;
  background-color: $c-red;
  color: white;
  padding: 38px 25px;
  position: relative;
  height: 120px;

  @media (max-width: 338px) {
    height: 144px;
  }
}
.date {
  font-size: 16px;
  text-transform: uppercase;
}
.title {
  font-size: 26px;
  font-weight: $fw-bold;
}
.close {
  outline: 0;
  background-color: transparent;
  border: none;
  outline: 0;
  cursor: pointer;
  padding: 0;
  margin: 0;
  float: right;
  z-index: 120;
  font-size: 0;
  width: 18px;
  height: 17px;
  margin-top: -15px;
  margin-right: -4px;
}
.panel-holder {
  overflow: hidden;
  max-height: 330px;

  @media (min-width: 768px) {
    max-height: 364px;
  }
}
.panel-holder-slide {
  transition: transform 200ms ease;
  will-change: transform;
}
.button {
  border-radius: 19.5px;
  height: 39px;
  font-size: 20px;
  background-color: #ffffff;
  color: $c-dark;
  border: none;
  outline: 0;
  cursor: pointer;
  box-shadow: 0 0 8px rgba($c-dark, 0.5);
  min-width: 167px;
  margin: 0 auto;
  position: absolute;
  bottom: -42px;
  left: calc(50% - 83px);
  padding: 0;
  transition: all .3s ease;
}
.button-anim-enter {
  opacity: 0;
  transform: scale(0.75);
}
.button-anim-leave-active {
  opacity: 0;
  transform: scale(0.75);
}
</style>



// WEBPACK FOOTER //
// src/components/alarm/DayDetail.vue